import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HisBackendService } from 'hisng';

import { DynamicClass } from 'app/fs/res/common/model/dynamic-content/dynamic-class';

/**
 * CRUD service for dynamic classes.
 */
@Injectable()
export class DynamicClassService {

    constructor( private backendService: HisBackendService ) { }

    createDynamicClass( data: any ): Observable<DynamicClass> {
        return this.backendService.postData( 'api/v1/cs/sys/dynamicClass', data );
    }

    getDynamicClass( id: number ): Observable<DynamicClass> {
        return this.backendService.getData( `api/v1/cs/sys/dynamicClass/${id}` );
    }

    updateDynamicClass( data: any ): Observable<DynamicClass> {
        return this.backendService.putData( `api/v1/cs/sys/dynamicClass/${data.id}`, data );
    }

    /**
     * Delete the dynamic class with the given id.
     *
     * @param id
     * @return Observable.of( 0=fail / 1=success )
     */
    deleteDynamicClass( id: number ): Observable<number> {
        return this.backendService.delete( `api/v1/cs/sys/dynamicClass/${id}` );
    }
}
